export default () => ({
  disabled: {
    opacity: 0.5,
  },
  show: {
    transition: 'opacity 0.3s',
  },
  hide: {
    display: 'none',
  },
  transparent: {
    opacity: 0,
  },
  opaque: {
    opacity: 1,
    '&.disabled': {
      opacity: 0.5,
    },
  },
});
